import styled from 'styled-components';
import {
  DeprecatedGrid as Grid,
  EllipsisWithLineClamp,
} from '@simplywallst/ui-core';

export const TopContainer = styled(Grid)`
  background-color: ${({ theme }) =>
    theme.color.chart06RGBA(
      0.1
    )}; // Grid doesn't accept backgroundColor with alpha :cry:
`;

export const TruncatedAnnouncement = styled('span')`
  ${EllipsisWithLineClamp(3)};
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme }) => theme.color.lightGray};

  * {
    display: inline;
  }
`;
